import React, { useContext, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import userContext from "../../context/users/UserContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import {  Dropdown, Icon, PrimaryButton } from "@fluentui/react";
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import "./ListViewStyles.css";
import PageHeader from "../PageHeader";
import ListViewTable from "../LisViewTable/ListViewTable";

const queryClient = new QueryClient();

const ListView = (props) => {

  const { roles, authenticated, loadByUsername, userId, firmId } =
    useContext(userContext);

  
  const [sortObj,setSortObj] = useState({
    sortFieldText : "",
    sortFieldValue : "",
    sortDir : false,
    selected : false
  });

  function camelToUnderscore(key) {
    var result = key.replace(/([A-Z])/g, " $1");
    return result.split(" ").join("_").toLowerCase();
  }

  useEffect(() => {
    if (!authenticated) {
      loadByUsername();
    }
  }, []);

  const dropdownStyles = {
    dropdown: { width: 200,background:"black",broderRadius:0 },
    title:{
        border: '1px solid #C8C6C4',
        borderRadius: '10px',
        background:'none',
        height:'29px',
        display:'flex',
        alignItem:'center'
    },
    dropdownItems: {
      selectors: {
        "@media(min-width: 640px)": {
          maxHeight: 300,
        },
      },
    },
  };

  const handleDropDownClick = (e,data) => {
    console.log(data);
    setSortObj(()=>{
      const newItem = {...sortObj};
      newItem.sortFieldText = data.text;
      newItem.sortFieldValue = data.key;
      newItem.sortDir = false;
      newItem.selected = true;
      return newItem;
    });
  }

  const changeSortDir = () => {
    setSortObj(()=>{
      const newItem = {...sortObj};
      newItem.sortDir = !sortObj.sortDir;
      return newItem;
    });
  }

  const clearSort = () => {
    setSortObj(()=>{
      const newItem = {...sortObj};
      newItem.sortFieldText = "";
      newItem.sortFieldValue = "";
      newItem.sortDir = false;
      newItem.selected = false;
      return newItem;
    });
  }


  return (<>
   <div className="main-container-body react-scroll">
            {/* <PageHeader header={props.pageHeader} /> */}
            <div className="top-section-list-view" style={{flexDirection:isMobile?"column":"row"}}>
            
            {/* <PrimaryButton onClick={()=>{handleSortClick()}} text="Sort Manual" /> */}
            
            <div className="filter-sort-list-view">
              <p className="sort-by-text">Sort By</p>
              {!sortObj.selected ? <Dropdown
                options={props.sortDropdownOptions}
                placeholder="Select"
                onChange={(e,data) => handleDropDownClick(e,data)}
                styles={dropdownStyles}
              />:
              <div className="badge-list-view" >
                  <span className="badge-text-list-view">{sortObj.sortFieldText}</span>
                  <Icon onClick={changeSortDir} style={{cursor:'pointer',color:'#0035BE',lineHeight:'2',marginLeft:'5px'}} iconName={sortObj.sortDir ? "SortUp" : "SortDown"} className="ms-fontSize-10"></Icon>
                  <Icon onClick={clearSort} style={{cursor:'pointer',color:'#0035BE',lineHeight:'2',marginLeft:'5px'}} iconName="Cancel" className="ms-fontSize-10"></Icon>
              </div>
              }
            </div>
            {props.buttonsTopBar.map((ele,index)=>{
              return ele.button
            })}
            </div>
           

            <QueryClientProvider client={queryClient}>
              <ListViewTable
                updateCurrentPage={props.updateCurrentPage}
                cacheTime={200}
                fetchFunction={props.fetchDataFunction}
                columns={props.columns}
                filterObj={props.filterObj}
                initialState={{}}
                sortObj={sortObj}
                setSelectedRowObj={props.setSelectedRowObj}
                selectedRowObj={props.selectedRowObj}
                sideBarComponent = {props.sideBarComponent}
                handleUserClick = {props.handleUserClick}
                widthContainer = {props.widthContainer == null || props.widthContainer == undefined ? 
                  "100%": props.widthContainer}
              />
              {/* <ReactQueryDevtools initialIsOpen={false} /> */}
            </QueryClientProvider>
          </div>
  </>)
    
};

export default ListView;
